import { debounce } from '../helpers/debounce';

export const BREAKPOINTS = Object.freeze({
  mobile: 361,
  tablet: 769,
  tabletLandscape: 1025,
  desktop: 1281,
  wide: 1601
});

export let isMobile = false;
export let isTablet = false;
export let isTabletLandscape = false;

const updateDeviceStatus = () => {
  const windowWidth = window.innerWidth;

  isMobile = windowWidth < BREAKPOINTS.mobile;
  isTablet = windowWidth < BREAKPOINTS.tablet;
  isTabletLandscape = windowWidth < BREAKPOINTS.tabletLandscape;
};

const handleResize = () => {
  updateDeviceStatus();
};

window.addEventListener('resize', debounce(handleResize, 250));

updateDeviceStatus();
